<template>
  <div>
    <ReactWrapper :component="MethodPreview" :props="props" />
  </div>
</template>

<script>
  import { MethodPreview } from '../../../../../frontendV2/dist/reactComponents';
  import ReactWrapper from '@/components/blocks/reactComponents/ReactWrapper';

  export default {
    name: 'MethodPreviewReact',

    components: {
      ReactWrapper,
    },

    props: {
      method: {
        type: Object,
        required: true,
      },
      methodOverride: {
        type: Object,
        default: null,
      },
      deviceConfiguration: {
        type: Object,
        required: true,
      },
      isReadOnly: {
        type: Boolean,
        default: true,
      },
    },

    data: () => ({
      MethodPreview,
    }),

    computed: {
      props() {
        return {
          method: this.method,
          methodOverride: this.methodOverride,
          deviceConfiguration: this.deviceConfiguration,
          isReadOnly: this.isReadOnly,
        };
      },
    },
  };
</script>
